import BordableModel from './BordableModel';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class ContainerModel extends BordableModel {

    layoutOrientation = new PropertyDescriptor('h', '布局方向', "容器", "enum", "#anticon-INGRESS-GLYPH-CREATE-", {
        gallery: "外观",
        values: [
            new PropertyDescriptor("v", "垂直", "布局方向", "string"),
            new PropertyDescriptor("h", "水平", "布局方向", "string"),
        ],
        description: "子部件将在哪个方向上进行布局（仅对布局方式为线性布局的子部件有效）",
        zIndex: -1,
    });

    flexWrap = new PropertyDescriptor(false, '允许换行', "容器", "bool", "#anticon-Linemanagement", {
        gallery: "外观",
        description: "当子部件在方向上排列不下时，是否允许换行排列",
        zIndex: -1,
    });

    alignItems = new PropertyDescriptor('flex-start', '线性排列', "容器", "enum", "#anticon-DrawAlignTop", {
        gallery: "外观",
        values: [
            new PropertyDescriptor("flex-start", "从头部开始", "排列方式", "string"),
            new PropertyDescriptor("center", "居中", "排列方式", "string"),
            new PropertyDescriptor("flex-end", "从尾部开始", "排列方式", "string"),
        ],
        description: "子部件在布局方向上以哪种方式进行排列",
        zIndex: -1,
    });

    justifyContent = new PropertyDescriptor('flex-start', '垂直排列', "容器", "enum", "#anticon-alignleft", {
        gallery: "外观",
        values: [
            new PropertyDescriptor("flex-start", "从头部开始", "垂直排列", "string"),
            new PropertyDescriptor("center", "居中", "垂直排列", "string"),
            new PropertyDescriptor("flex-end", "从尾部开始", "垂直排列", "string"),
        ],
        description: "子部件在布局方向的垂直方向上以哪种方式进行排列",
        zIndex: -1,
    });

    overflowX = new PropertyDescriptor(false, '水平滚动', "容器", "bool", "#anticon-ui-scroll-pane-horiz", {
        gallery: "外观",
        description: "当子元素超出容器范围时，是否允许出现水平滚条",
        zIndex: -1,
    });

    overflowY = new PropertyDescriptor(false, '垂直滚动', "容器", "bool", "#anticon-ui-scroll-pane", {
        gallery: "外观",
        description: "当子元素超出容器范围时，是否允许出现垂直滚条",
        zIndex: -1,
    });

    isExpanded = new PropertyDescriptor(true, "子部件是否展开", "容器", "bool", undefined, { enabled: false });

    enableContainerModelProperties(enabled) {
        this.layoutOrientation.enabled = enabled;
        this.flexWrap.enabled = enabled;
        this.alignItems.enabled = enabled;
        this.overflowX.enabled = enabled;
        this.overflowY.enabled = enabled;
    }

    toContainerStyle() {

        return {
            display: `flex`,
            flexDirection: (this.layoutOrientation === "v" ? "column" : "row"),
            flexWrap: this.flexWrap ? "wrap" : "unset",
            alignContent: "flex-start",
            alignItems: this.alignItems,
            justifyContent: this.justifyContent,
        }
    }

    toStyle() {

        return {
            ...super.toStyle(),
            overflowY: this.overflowY ? "auto" : "unset",
            overflowX: this.overflowX ? "auto" : "unset",
        }
    }
}
